import React, { ReactNode } from 'react';
import SharedSelection from './SharedSelection';
import { useTranslationKeyPath } from 'app/models/entityStateSync/keypath';
import { EntityFields, EntityStringId, IEntityType, IEntity } from 'app/types/entity';
import { ExtractProps } from 'app/utils/types';
import { Language } from 'app/constants/enums/Language';

interface IProps<T extends IEntity>
extends Omit<ExtractProps<typeof SharedSelection>, 'path'> {
  readonly id: EntityStringId;
  readonly field: keyof EntityFields<T>;
  readonly language: Language;
  readonly type: IEntityType<T>;
  readonly children: ReactNode;
}

export default function EntityTranslationSharedSelection<T extends IEntity>(
  { type, id, field, language, ...props }: IProps<T>,
) {
  const keyPath = useTranslationKeyPath({ language, id, field, type });
  return (
    <SharedSelection {...props} path={keyPath} />
  );
}
